/**
 * ROUTE DEFINITIONS
 *
 * Every route in the app is defined here with metadata.
 * WHY metadata? The RouteGuard reads `requiresAuth` and `roles` to decide
 * if the current user is allowed to see the page. The layout reads `title`
 * for breadcrumbs and the browser tab.
 *
 * HOW svelte-spa-router works:
 * It uses HASH-based routing (e.g., /#/login, /#/dashboard).
 * This means you don't need server-side URL rewriting — perfect for
 * static hosting (Cloudflare Pages, Netlify, GitHub Pages).
 */
// ---- Central route metadata map ----
// The key is the hash path (e.g., '/login', '/dashboard')
export const ROUTE_META = {
    '/login': {
        title: 'Login',
        requiresAuth: false,
        isPublic: true, // If user is already logged in, redirect to /dashboard
    },
    '/dashboard': {
        title: 'Dashboard',
        requiresAuth: true,
    },
    '/admin': {
        title: 'Admin Panel',
        requiresAuth: true,
        roles: ['admin'], // Only admin role can access this page
    },
    '/': {
        title: 'Dashboard',
        requiresAuth: true,
    },
    '*': {
        title: 'Not Found',
        requiresAuth: true,
    },
};
// ---- Helper: get metadata for current route ----
export function getRouteMeta(path) {
    return ROUTE_META[path] || {
        title: 'Not Found',
        requiresAuth: false,
    };
}
//# sourceMappingURL=routes.js.map